import React from 'react';
import Hero from './Hero';
import Products from './Products';
import Features from './Features';
import Services from './Services';
import About from './About';
import Contact from './Contact';
import Footer from './Footer';
import './LandingPage.css';

const LandingPage = () => {
  return (
    <div className="landing-page">
      <Hero />
      <Products />
      <Features />
      <Services />
      <About />
      <Contact />
      <Footer />
    </div>
  );
};

export default LandingPage;
